import * as React from "react";
import Svg, { Path } from "react-native-svg";

const A = (props) => (
  <Svg
    width={113}
    height={100}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M47.768 0H69.53c1.978 0 3.728 1.218 4.489 3.044l35.688 89.486c1.217 3.12-1.065 6.544-4.49 6.544H85.662c-2.054 0-3.88-1.294-4.49-3.196L67.249 56.385H48.376l-12.403 39.34c-.608 1.98-2.51 3.349-4.565 3.349h-19.48c-3.425 0-5.707-3.424-4.414-6.544l35.84-89.486C44.04 1.14 45.865 0 47.768 0Zm19.48 56.385-6.164-17.349c-1.065-3.12-5.479-3.12-6.62 0L48.3 56.386h18.948Z"
      fill="#fff"
    />
    <Path
      d="M108.947 18.719H88.021c-2.891 0-4.261 3.424-2.283 5.479l5.555 5.555c.305.304.305.76 0 .989L50.05 71.984c-.304.305-.684.305-.989 0L34.756 57.68l-3.5-3.5c-1.599-1.598-4.262-1.598-5.86 0L1.198 78.376c-1.597 1.598-1.597 4.262 0 5.86l2.968 2.967c1.598 1.598 4.261 2.36 5.86.761L27.83 70.158c.305-.304.685-.304.99 0l11.566 11.567 6.163 6.163c1.598 1.598 4.261.837 5.86-.76l1.521-1.523c.076-.076.229.609.305.533l45.884-45.885c.304-.304.685-1.065.989-.76l5.555 5.554c2.055 2.055 5.479.61 5.479-2.282V21.839c0-1.674-1.446-3.12-3.196-3.12Z"
      fill="#48A9C2"
    />
    <Path
      d="M109.403 15.447H88.478c-2.892 0-4.261 3.424-2.283 5.479l5.555 5.555c.304.304.304 0 0 .228L50.507 67.95c-.304.305-.685 1.066-.99.761L35.213 54.407l-3.5-3.5c-1.598-1.598-4.261-1.598-5.86 0L1.656 72.06c-1.598 1.597-1.598 7.304 0 8.902l2.968 2.968c1.598 1.598 4.26 1.598 5.859 0l17.806-17.806c.304-.304.685-.304.989 0l17.73 17.73c1.598 1.598 4.261 1.598 5.859 0l1.522-1.522c.076-.076.228-.152.304-.228l45.885-45.885c.304-.304.684-.304.989 0l5.555 5.555c2.054 2.055 5.478.61 5.478-2.282V18.567c0-1.674-1.445-3.12-3.196-3.12Z"
      fill="#48A9C2"
    />
    <Path
      d="M108.947 17.197H88.021c-2.891 0-4.261 3.424-2.283 5.479l5.555 5.555c.305.304.305.76 0 .989L50.05 70.463c-.304.304-.684.304-.989 0L34.756 56.157l-3.5-3.5c-1.599-1.598-4.262-1.598-5.86 0L1.198 76.855c-1.597 1.597-1.597 4.26 0 5.859l2.968 2.967c1.598 1.598 4.261 1.598 5.86 0L27.83 67.875c.305-.304.685-.304.99 0l17.73 17.73c1.597 1.598 4.26 1.598 5.858 0l1.522-1.522c.076-.076.229-.152.305-.228l45.884-45.884c.304-.305.685-.305.989 0l5.555 5.555c2.055 2.054 5.479.608 5.479-2.283V20.317c0-1.674-1.446-3.12-3.196-3.12Z"
      fill="#fff"
    />
    <Path
      d="m63.443 57.07-15.219-.076.533-1.598h14.686v1.674Z"
      fill="#48A9C2"
    />
  </Svg>
);

export default A;
